export default __webpack_public_path__ + "static/media/cr_white.d336156d.png";